<template>
  <path
    d="M7 14.0002C5.34 14.0002 4 15.3402 4 17.0002C4 18.3102 2.84 19.0002 2 19.0002C2.92 20.2202 4.49 21.0002 6 21.0002C8.21 21.0002 10 19.2102 10 17.0002C10 15.3402 8.66 14.0002 7 14.0002ZM20.71 4.63018L19.37 3.29018C18.98 2.90018 18.35 2.90018 17.96 3.29018L9 12.2502L11.75 15.0002L20.71 6.04018C21.1 5.65018 21.1 5.02018 20.71 4.63018Z"
  />
</template>
